export default __webpack_public_path__ + "static/media/Baumer.3d879d8a.png";